import KitchenWindowConnectedCountertop from './KitchenWindowConnectedCountertop';

export default KitchenWindowConnectedCountertop;